/**
 * DiscoveryScopeBanner — Iter-290b Sprint D (#8)
 *
 * Shown to clients whose talent discovery results are scope-pinned by their
 * subscription tier. Standard plan = state-only; Premium/Enterprise/legacy
 * grandfathered = nationwide.
 *
 * Props:
 *   scopeLock : { state, tier, reason } | null   ← from /api/discover/talent
 *   onUpgrade : () => void   (defaults to navigating to subscription page)
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, MapPin } from 'lucide-react';

export default function DiscoveryScopeBanner({ scopeLock, onUpgrade }) {
  const navigate = useNavigate();
  if (!scopeLock || !scopeLock.state) return null;
  return (
    <div
      className="mb-3 flex items-center gap-3 px-4 py-3 rounded-xl border border-amber-200 bg-gradient-to-r from-amber-50 to-yellow-50 text-amber-900"
      data-testid="discovery-scope-banner"
    >
      <MapPin className="w-5 h-5 text-amber-600 shrink-0" />
      <div className="flex-1 text-sm">
        Showing <strong>{scopeLock.state}</strong> talent only — your <strong className="capitalize">{scopeLock.tier}</strong> plan limits discovery to your home state.
      </div>
      <button
        type="button"
        onClick={() => (onUpgrade ? onUpgrade() : navigate('/client/settings/subscription'))}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold shrink-0"
        data-testid="discovery-scope-upgrade-btn"
      >
        <Crown className="w-4 h-4" /> Upgrade for nationwide
      </button>
    </div>
  );
}
